export default {"src":"/_next/static/image/public/images/ic_bookmark_checked_blue.9bc1a87c2c955243ef5a575b09bb2f47.svg","height":18,"width":14};